import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import convertToFormErrors from 'utils/convertToFormErrors';
import { withRouter, Link } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import SubmitButton from 'form/SubmitButton';
import { invalidateRequests, query } from 'redux-bees';

@query('account', api.getAccount)
@query('plans', api.getPlans)

@withRouter


@reduxForm({
  form: 'CreateSite',
  validate: generateFormValidation({
    wpUsername: [validators.required()],
    name: [validators.required()],
    wpEmail: [validators.required()],
    wpPassword: [validators.required()],
  }),
  onSubmit(values, dispatch, props) {
    return dispatch(api.createSite({
      data: {
        type: 'site',
        attributes: values,
      },
    }))
    .then(() => {
      props.history.push('/sites');
      dispatch(invalidateRequests(api.getSites));
      dispatch(notice('CreateSite.success'));
    })
    .catch((response) => {
      dispatch(alert('CreateSite.error'));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class CreateSite extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
    account: PropTypes.object,
    plans: PropTypes.array,
  }

  renderForm() {
    const { handleSubmit, submitting, error, dirty, account } = this.props;

    return (
      <Form error={error} onSubmit={handleSubmit}>
        <Field label="CreateSite.name" name="name" placeholder="My first WordPress site">
          <input type="text" placeholder="My Site" />
        </Field>
        <Field label="CreateSite.wpUsername" name="wpUsername" placeholder="admin">
          <input type="text" />
        </Field>
        <Field label="CreateSite.wpEmail" name="wpEmail" placeholder={account.attributes.email}>
          <input type="text" />
        </Field>
        <Field label="CreateSite.wpPassword" name="wpPassword" placeholder="****">
          <input type="password" />
        </Field>
        <SubmitButton
          dirty={dirty}
          className="wp-button"
          submitting={submitting}
          label="CreateSite.submit"
        />
      </Form>
    );
  }

  renderCta() {
    return (
      <div className="blank-slate blank-slate--no-border blank-slate--tiny">
        <div className="blank-slate__title">
          Plan limits reached :/
        </div>
        <p className="blank-slate__description">
          Your current plan does not allow creating new sites, please upgrade
          to a bigger plan!
        </p>
        <div className="blank-slate__actions">
          <Link
            to={'/account'}
            className="button button--large button--primary"
          >
            Upgrade plan
          </Link>
        </div>
      </div>
    );
  }

  renderBody() {
    const { account, plans } = this.props;

    if (!account || !plans || !account.attributes.sitesCounter === 0) {
      return <div />;
    }

    const currentPlan = plans.find(plan => (
      plan.id === account.relationships.plan.data.id
    ));

    if (account.attributes.isDeactivated ||
      (currentPlan.attributes.sitesLimit &&
      currentPlan.attributes.sitesLimit <= account.attributes.sitesCounter)
    ) {
      return this.renderCta();
    }

    return this.renderForm();
  }

  render() {
    return (
      <div className="wp-island wp-island--large wp-island--modal">
        <div className="wp-island__wrap">
          <div className="wp-island__logo">
            <img src="/assets/images/wordpress-logo.svg" alt="" height="84" />
          </div>
          <div className="wp-island__content">
            {this.renderBody()}
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/CreateSite.jsx